import React, { useState, useEffect } from "react";
import "./ComposeSMS.css";

const ComposeSMS = () => {
    const [message, setMessage] = useState("");
    const [phoneNumbers, setPhoneNumbers] = useState("");
    const [uploadFile, setUploadFile] = useState(null);
    const [language, setLanguage] = useState("English");
    const [senderId, setSenderId] = useState("");
    const [senderList, setSenderList] = useState([]);

    const [showTemplates, setShowTemplates] = useState(false);
    const [templates, setTemplates] = useState([]);

    useEffect(() => {
        fetch("https://prod-erp.nifty10.in/api/senderids")
            .then(res => res.json())
            .then(data => {
                if (data && data.SenderIds) {
                    setSenderList(data.SenderIds);
                    if (data.SenderIds.length > 0) setSenderId(data.SenderIds[0].SenderId);
                }
            })
            .catch(err => console.error("Error fetching sender IDs:", err));
    }, []);

    const loadTemplates = () => {
        fetch("https://prod-erp.nifty10.in/api/templates")
            .then(res => res.json())
            .then(data => {
                if (data && data.Templates) {
                    setTemplates(data.Templates);
                    setShowTemplates(true);
                }
            })
            .catch(err => console.error("Error fetching templates:", err));
    };

    const handleFileChange = (e) => setUploadFile(e.target.files[0]);

    const handleSend = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("message", message);
        formData.append("numbers", phoneNumbers);
        formData.append("senderId", senderId);
        if (uploadFile) formData.append("file", uploadFile);

        try {
            const res = await fetch("https://prod-erp.nifty10.in/api/send-sms", {
                method: "POST",
                body: formData
            });
            const data = await res.json();
            alert(`SMS Status: ${data.status || "Sent"}`);
        } catch (err) {
            console.error(err);
            alert("Failed to send SMS");
        }
    };

    const handleTemplateSelect = (templateContent) => {
        setMessage(templateContent);
        setShowTemplates(false);
    };
    const handleCancel = () => {
        setMessage("");
        setPhoneNumbers("");
        setUploadFile(null);
        setLanguage("English");
        setSenderId(senderList.length > 0 ? senderList[0].SenderId : "");
    };

    return (
        <div className="compose-sms-container">
            <div className="compose-main">
                <h2>Compose SMS</h2>
                <form onSubmit={handleSend}>
                    <div>
                        <label>Your Message :</label>
                        <textarea
                            className="full-width"
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                            maxLength={500}
                            placeholder="Enter your message here."
                        />
                        <span className="char-count">{message.length}/500</span>
                    </div>

                    <div>
                        <label>Phone Numbers :</label>
                        <textarea
                            className="full-width"
                            value={phoneNumbers}
                            onChange={e => setPhoneNumbers(e.target.value)}
                            placeholder="Enter multiple mobile numbers separated by (,) comma."
                        />
                        {/* <small>
                            <b>Note:</b> Only distinct numbers will be processed, duplicates will be omitted.
                        </small> */}
                    </div>

                    <div className="form-group">
                        <label>Upload File :</label><br />
                        <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
                    </div>

                    {/* <div>
                        <label>Choose Language</label><br />
                        <select
                            value={language}
                            onChange={e => setLanguage(e.target.value)}
                            className="full-width"
                        >
                            <option>English</option>
                            <option>Hindi</option>
                        </select>
                    </div> */}

                    <div>
                        <label>Select Sender Id</label><br />
                        <select
                            value={senderId}
                            onChange={e => setSenderId(e.target.value)}
                            className="full-width"
                        >
                            {senderList.map((s, i) => (
                                <option key={i} value={s.SenderId}>{s.SenderId}</option>
                            ))}
                        </select>
                    </div>

                    <button
                        type="button"
                        className="sidebar-btn template-btn"
                        onClick={loadTemplates}
                    >
                        + My Templates
                    </button>

                    <div className="button-row">
                        <button type="submit" className="sms-send-btn">Send</button>
                        <button
                            type="button"
                            className="sms-cancel-btn"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>

                    </div>
                </form>
            </div>

            {showTemplates && (
                <div className="template-modal">
                    <div className="template-modal-content">
                        <div className="close-x-btn cross-btn" onClick={() => setShowTemplates(false)} aria-label="Close">
                            <i className="fa-solid fa-circle-xmark"></i>
                        </div>

                        <h2 style={{ textAlign: "center", marginBottom: 18 }}>Select a Template</h2>
                        <table>
                            <thead>
                                <tr>
                                    <th>Sender ID</th>
                                    <th>Template Content</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {templates.map(t => (
                                    <tr key={t.TemplateId}>
                                        <td>{t.Name}</td>
                                        <td>{t.Template}</td>
                                        <td>
                                            <button
                                                className="select-template-btn"
                                                onClick={() => handleTemplateSelect(t.Template)}
                                            >
                                                Select
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ComposeSMS;
